// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef, useRef, useState } from 'react';
import Volume100Icon from '../../../../assets/images/volume-100.svg';
import Volume60Icon from '../../../../assets/images/volume-60.svg';
import Volume30Icon from '../../../../assets/images/volume-30.svg';

import S from './styles'

interface VolumeBarProps extends Omit<ComponentPropsWithRef<'div'>, 'onVolumeChange'> {
  volume: number;
  muted: boolean;
  onMutedChange: (mute: boolean) => void;
  onVolumeChange: (volume: number) => void;
}

const VolumeBar: React.FC<VolumeBarProps> = (props) => {
  const {
    volume,
    muted,
    onMutedChange,
    onVolumeChange,
  } = props;

  const [isVolumeHovering, setIsVolumeHovering] = useState(false);
  const [volumeSeeking, setVolumeSeeking] = useState(false);

  const rect = useRef<DOMRect>()

  const handleVolumeMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setVolumeSeeking(true);

    rect.current = e.currentTarget.getBoundingClientRect();
    handleVolumeChange(e.nativeEvent)

    window.addEventListener('mousemove', handleVolumeChange);
    window.addEventListener('mouseup', handleVolumeMouseUp);
  }

  const handleVolumeChange = (e: MouseEvent) => {
    if (!rect.current) return;

    const y = e.clientY - rect.current.y;
    const height = rect.current.height;
    const percentage = 1 - Math.min(1, Math.max(0, y / height));
    onVolumeChange(percentage);
    onMutedChange(percentage === 0);
  }

  const handleVolumeMouseUp = () => {
    window.removeEventListener('mousemove', handleVolumeChange);
    window.removeEventListener('mouseup', handleVolumeMouseUp);
    setVolumeSeeking(false);
  }

  const handleMute = () => {
    onMutedChange(!muted);
  }

  const handleShowVolumeBar = () => setIsVolumeHovering(true);
  const handleHideVolumeBar = () => setIsVolumeHovering(false);

  return (
    <S.VolumeContainer
      onMouseEnter={handleShowVolumeBar}
      onMouseLeave={handleHideVolumeBar}
    >
      <S.VolumeBarDetectArea isShown={isVolumeHovering || volumeSeeking}>
        <S.VolumeBar onMouseDown={handleVolumeMouseDown}>
          <S.Volume volume={muted ? 0 : volume} />
        </S.VolumeBar>
      </S.VolumeBarDetectArea>
      {muted && <S.VolumeMuted onClick={handleMute}></S.VolumeMuted>}
      {!muted && <S.VolumeOn src={volume <= 0.3 ? Volume30Icon : volume <= 0.6 ? Volume60Icon : Volume100Icon} onClick={handleMute}></S.VolumeOn>}
    </S.VolumeContainer>
  )
}

export { VolumeBar as default }
